import type { RequisitionDetail } from '@nest-recruit/shared';

/** Set only when a request is sent (F4.02), so a draft that has it was sent and came back. */
export function wasSentBefore(existing: Pick<RequisitionDetail, 'submittedAt'> | null): boolean {
  return (existing?.submittedAt ?? null) !== null;
}

/** QA D79: a draft never sent is still "Request a hire"; only one sent and returned is "Fix". */
export function headingOf(existing: Pick<RequisitionDetail, 'reference' | 'submittedAt'> | null, isCheck: boolean): string {
  if (!existing) return 'Request a hire';
  if (isCheck) return `Check ${existing.reference}`;
  return wasSentBefore(existing) ? `Fix ${existing.reference}` : `Request a hire, ${existing.reference}`;
}
